module.exports = "/wwwroot/img/lift_container_block.png?ver=d1395bba";